import Resources from "./Resources";
import VideoLibrary from "./VideoLibrary";
import labels from "utils/LocalizedStrings";
import SectionFooter from "common/Footer/SectionFooter";
import { useState, useEffect } from "react";
import Spinner from "common/Spinner/Spinner";
import { APIEndpoints } from "utils/APIEndpoints";
import ErrorMessage from "common/ErrorMessage/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { setParticipantDetails } from "store/authSlice";
import GuestCenter from "./GuestCenter";

const LearningCenter = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [resources, setResources] = useState([]);
  const [videos, setVideos] = useState([]);
  const location = useLocation();
  const dispatch = useDispatch();

  const participantDetails = useSelector(
    (state) => state?.authReducer?.participantDetails
  );
  const clientConfig = useSelector(
    (state) => state?.commonReducer?.clientConfig
  );
  const guestUser = participantDetails && participantDetails?.guestPpt;
  const videoLibrary = location.pathname === "/video-library";

  const getResources = async () => {
    const tenant = localStorage.getItem("tenant");
    setLoading(true);
    try {
      const resourcesRes = await fetch(APIEndpoints.resources(tenant));
      const videosRes = await fetch(APIEndpoints.videos(tenant));
      setResources(await resourcesRes.json());
      setVideos(await videosRes.json());
    } catch (err) {
      setErrors(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location.pathname === "/learning-page") {
      dispatch(
        setParticipantDetails({
          planStateCode: "MN",
          extPlanId: "583003-01",
        })
      );
    }
    getResources();
  }, []);

  return (
    <main
      id="learning-center"
      className={`${guestUser ? "guest" : "non-guest"}`}
    >
      {loading && <Spinner />}
      {errors && !loading && <ErrorMessage error={errors} />}
      <section
        className={`dashboard-layout shadow-lg ${
          videoLibrary ? "video-library" : ""
        }`}
      >
        {resources?.length ? (
          <Resources
            labels={labels}
            resources={resources}
            participantDetails={participantDetails}
            clientConfig={clientConfig}
          />
        ) : (
          ""
        )}
        {videos.length ? (
          <VideoLibrary
            labels={labels}
            videos={videos}
            participantDetails={participantDetails}
          />
        ) : (
          ""
        )}
        <GuestCenter
          labels={labels}
          resources={resources}
          participantDetails={participantDetails}
          clientConfig={clientConfig}
        />
      </section>
      <SectionFooter page="learningCenter" />
    </main>
  );
};

export default LearningCenter;
